// Styles here will override Bulma styles
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const styledSection = css`
  padding-top: 64px;
  padding-bottom: 64px;
`;

export const styledContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 940px;
  padding: 32px;
  text-align: center;

  ${media('< tablet')} {
    padding: 16px;
  }
`;

export const styledIcon = css`
  max-height: 80px;
`;

export const styledHeading = css`
  margin-left: 32px;
  ${media('< tablet')} {
    margin: 32px 0 0 0;
  }
`;

export const StyledSubheading = styled.div`
  p {
    color: #5b6987;
    font-size: 16px;
    margin: 32px 0;
  }
`;
